import {svgIconWrapper} from '../svg-icon-wrapper';

import PersonExitDoorRegular from './person-exit-door-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <PersonExitDoorRegular {...props} />;
}

SvgComponent.iconName = 'personExitDoorRegular';

export const PersonExitDoorRegularIcon = svgIconWrapper(SvgComponent);
